import { toPng } from "html-to-image";
import { forwardRef, useImperativeHandle, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import HorizontalStackedBarChart from "../../../components/chart/HorizontalStackedBarChart";
import StandardChartContainer from "../../../components/container/StandardChartContainer";
import { useTheme } from "@mui/material";
import { GRAPH_PALETTE } from "../../../theme/style/graphChartPalette";

const FLOW_KEYS = ["recycled", "reuse", "biological", "energyRecovery", "waste"];

const OutputMaterialChart = forwardRef(({ circularities, height }, parentRef) => {
  const { t } = useTranslation();
  const ref = useRef();
  const dataKeys = ["Recycled (%)", "Reuse (%)", "Composted (%)", "Energy Recovery (%)", "Waste content (%)"];
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  // One circularity flow token per data key, in the same order as dataKeys.
  const getColor = (index) => {
    const flow = GRAPH_PALETTE.circularityFlows[FLOW_KEYS[index % FLOW_KEYS.length]];
    return isDark ? flow.dark : flow.light;
  };
  useImperativeHandle(parentRef, () => ({
    getScreenshot: async () => {
      if (ref.current) {
        return await toPng(ref.current, { cacheBust: true, backgroundColor: "#ffffff" });
      }
      return null;
    },
  }));
  const outputData = useMemo(() => {
    const data = (circularities || []).map((item) => {
      const desc = item.description || item.name || t("Unknown Material");
      return {
        name: desc,
        label: desc,
        "Recycled (%)": parseFloat(item.om_recycling) || 0,
        "Reuse (%)": parseFloat(item.om_reuse) || 0,
        "Composted (%)": parseFloat(item.om_bio_composted) || 0,
        "Energy Recovery (%)": parseFloat(item.om_bio_energy_recovery) || 0,
        "Waste content (%)": parseFloat(item.om_waste_content) || 0,
      };
    });
    return data;
  }, [circularities]);

  return (
    <StandardChartContainer ref={ref}>
      <HorizontalStackedBarChart
        title={"Output Materials"}
        height={height}
        data={outputData}
        dataKeys={dataKeys}
        getColor={getColor}
        showLegend
        xAxisLabel="Percentage (%)"
        yAxisLabel="Materials"
        hideDownload
      />
    </StandardChartContainer>
  );
});

export default OutputMaterialChart;
